const BARTER_PARCEL_TYPE = {
    concerned: 'concerned',
    counterparty: 'counterparty',
    passed: 'passed',
    received: 'received'
}

export default BARTER_PARCEL_TYPE

export enum BarterParcelTypeEnum {
    concerned = 'concerned',
    counterparty = 'counterparty',
    passed = 'passed',
    received = 'received'
}